import styles from "./GlobalAdminItem.module.css";
import PropTypes from "prop-types";

/**
 *
 * Displays information about a group in a group list.
 */

export function GlobalAdminItem({ adminInfo, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.item}>{adminInfo.adminName}</div>
      <div className={styles.item}>{adminInfo.email}</div>
      <div className={styles.item}>{adminInfo.accessLevel}</div>
      <div className={styles.item}>
        <button className={styles.button} onClick={() => onClick(adminInfo)}>
          Remove
        </button>
      </div>
    </div>
  );
}

GlobalAdminItem.propTypes = {
  adminInfo: PropTypes.object,
  onClick: PropTypes.func,
};
